<template>
	<div class="sousBox">
		<div class="sousInput">
			<input type="text" @click.stop="" @focus="flag = true" @keyup.enter="sousFn('')" v-model="word" placeholder="输入你想要的搜索内容" />
		</div>
		<div class="sousBtn supHove3" @click="sousFn('')">
			<img src="@/assets/img/searIcon.svg" alt="" />
			搜索
		</div>
		<div class="sousCont" v-show="flag" @click.stop="" :class="flag ? 'sousBox1' : ''" v-clickaway="blFn">
			<div class="sousContTit" @click="sIconFn">
				搜索历史
				<img src="@/assets/img/sous.png" alt="" />
			</div>
			<div class="sousContBox">
				<div v-if="hisData && hisData.length" style="width: 100%">
					<div class="sousContBoxItem" :title="item.word" v-for="(item, index) in hisData" :key="index" @click="sousFn(item.word)">
						{{ item.word }}
					</div>
				</div>
				<p v-else>暂无记录</p>
			</div>
		</div>
	</div>
</template>

<script>
import { mapState, mapActions } from 'vuex';

export default {
	name: 'searchSousuo',
	data() {
		return {
			flag: false,
			setFn: '',
			delFlag: false,
			word: ''
		};
	},
	methods: {
		...mapActions({ setHisFn: 'setHisData', addHisFn: 'addHisData' }),
		sIconFn() {
			clearTimeout(this.setFn);
			this.$confirm('是否清除历史记录?', '提示', {
				confirmButtonText: '确定',
				confirmButtonClass: 'delBtns',
				cancelButtonText: '取消',
				type: 'warning'
			})
				.then(() => {
					this.$http.delete('api/app/yydSearchRecords/remove').then((res) => {
						if (res.code == 200) {
							this.$message({
								type: 'success',
								message: '删除成功'
							});
							this.$store.dispatch('setHisData');
						}
					});
				})
				.catch(() => {});
		},
		sousFn(txt) {
			this.flag = false;
			if (!txt && this.word) {
				this.addHisFn(this.word);
			}
			console.log(this.word, txt, 8888);
			console.log(this.$route);
			if (txt) {
				this.word = txt;
			}
			if (!this.word) {
				this.$message({
					type: 'warning',
					message: '请输入搜索内容'
				});
				return;
			}
			if (this.$route.path == '/searPage') {
				this.$bus.$emit('someEvent', this.word);
			} else {
				this.$router.push({
					path: 'searPage',
					query: {
						word: this.word
					}
				});
			}
		},
		blFn() {
			this.flag = false;
		},
		searList() {
			if (this.hisData && this.hisData.length == 0) {
				this.setHisFn();
			}
		}
	},
	computed: {
		...mapState(['hisData'])
	},
	components: {},
	mounted() {
		let { word } = this.$route.query;
		this.word = word;
		this.searList();
	}
};
</script>
<style lang="scss" scoped>
.sousBox {
	display: flex;
	position: relative;
	height: 40px;
	.sousCont {
		position: absolute;
		top: 40px;
		left: 0;
		width: 100%;
		background: #fff;
		border-radius: 0 0 5px 5px;
		padding: 11px 14px;
		box-sizing: border-box;
		z-index: 99;
		.sousContTit {
			color: #b8b8b8;
			font-size: 12px;
			display: flex;
			align-items: center;
			margin-bottom: 15px;
			cursor: pointer;
			img {
				width: 14px;
				height: 14px;
				margin-left: 5px;
			}
		}
		.sousContBox {
			display: flex;
			> div {
				display: flex;
				flex-wrap: wrap;
			}
			p {
				color: #666666;
				text-align: center;
				flex: 1;
				font-size: 12px;
			}
			.sousContBoxItem {
				max-width: 86px;
				padding: 7px 13px;
				box-sizing: border-box;
				background: #f8f9fa;
				border-radius: 4px;
				font-size: 12px;
				color: #000000;
				cursor: pointer;
				margin-bottom: 9px;
				margin-right: 10px;
				overflow: hidden;
				text-overflow: ellipsis;
				white-space: nowrap;
				&:hover {
					background: #f8f9fa;
					color: #1d7b3a;
				}
			}
		}
	}
	.sousInput {
		width: 540px;
		box-sizing: border-box;
		border-radius: 5px 0 0 5px;
		border: 1px solid #1d7b3a;
		padding-left: 10px;
		font-size: 14px;
		background: #f3f4f7;
		input {
			width: 100%;
			height: 100%;
			background: #f3f4f7;
			&::placeholder {
				color: #c3c3c3;
			}
		}
	}
	.sousBtn {
		width: 98px;
		display: flex;
		justify-content: center;
		align-items: center;
		color: #fff;
		font-size: 14px;
		background: #1d7b3a;
		border-radius: 0 5px 5px 0;
		cursor: pointer;

		img {
			width: 15px;
			height: 15px;
			margin-right: 4px;
		}
	}
}
.sousBox1 {
	box-shadow: 0px 3px 15px 0px rgba(0, 0, 0, 0.1);
}
</style>
